import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Logout from '../../components/Logout/Logout';
import LogoutAction from '../actions/LogoutAction';

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    submitLogout: LogoutAction.submitLogout
  }, dispatch);

const LogoutContainer = connect(null, mapDispatchToProps)(Logout);

export default LogoutContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/LogoutContainer.js
 **/